/** AST leaf helpers for RA bill formula builders. */

export const fieldRef = (fieldCode) => ({ type: 'FIELD', fieldCode });
export const constant = (value) => ({ type: 'CONSTANT', value: Number(value) || 0 });
export const previousRaRef = (fieldCode, fallback = 0) => ({
  type: 'PREVIOUS_RA_FIELD',
  fieldCode,
  fallback,
});
export const projectRef = (fieldCode, fallback = 0) => ({
  type: 'PROJECT_FIELD',
  fieldCode,
  fallback,
});
export const agreementRef = (fieldCode, fallback = 0) => ({
  type: 'AGREEMENT_FIELD',
  fieldCode,
  fallback,
});
export const departmentRef = (fieldCode, fallback = 0) => ({
  type: 'DEPARTMENT_FIELD',
  fieldCode,
  fallback,
});

export const op = (operator, argumentsList, extra = {}) => ({
  operator,
  arguments: argumentsList,
  ...extra,
});

export const rateNodeFromSource = (cfg) => {
  const rate = Number(cfg.rateValue);
  const rateSource = String(cfg.rateSource || 'FIXED').toUpperCase();
  const fallback = Number.isFinite(rate) ? rate : 0;
  // Map common recovery roles to department FY keys when rateFieldCode omitted.
  const inferredDeptKey = cfg.rateFieldCode || ({
    SECURITY_DEPOSIT: 'security_deposit_pct',
    GST_DEDUCTION: 'gst_pct',
    INCOME_TAX: 'income_tax_pct',
    LABOUR_CESS: 'labour_cess_pct',
  }[String(cfg.financialClassification || cfg.semanticRole || '').toUpperCase()]
    || null);

  if (rateSource === 'DEPARTMENT') {
    return departmentRef(inferredDeptKey || 'security_deposit_pct', fallback);
  }
  if (rateSource === 'PROJECT' && cfg.rateFieldCode) {
    return projectRef(cfg.rateFieldCode, fallback);
  }
  if (rateSource === 'AGREEMENT' && cfg.rateFieldCode) {
    return agreementRef(cfg.rateFieldCode, fallback);
  }
  return constant(fallback);
};
